var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuccessConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 22.2151C0.25 34.3462 10.0848 44.1802 22.2151 44.1802C34.3455 44.1802 44.1802 34.3462 44.1802 22.2151C44.1802 10.0854 34.3448 0.25 22.2151 0.25C10.0854 0.25 0.25 10.0854 0.25 22.2151ZM22.2151 41.1802C11.7416 41.1802 3.25 32.6893 3.25 22.2151C3.25 11.7423 11.7423 3.25 22.2151 3.25C32.688 3.25 41.1802 11.7423 41.1802 22.2151C41.1802 32.6893 32.6887 41.1802 22.2151 41.1802ZM30.5612 18.4198C31.147 17.834 31.147 16.8843 30.5612 16.2985C29.9755 15.7127 29.0257 15.7127 28.4399 16.2985L19.7876 24.9508L15.9899 21.1546C15.4039 20.569 14.4542 20.5692 13.8685 21.1551C13.2829 21.741 13.2831 22.6907 13.869 23.2764L18.7274 28.1328C19.3132 28.7184 20.2628 28.7183 20.8485 28.1326L30.5612 18.4198Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessConfirm);
export default __webpack_public_path__ + "static/media/iconSuccessConfirm.b113e303.svg";
export { ForwardRef as ReactComponent };